import { CLERY_LOCATION } from '../constants/addAddressFormConstants';
import {
  POSTAL_CODE_REGEX,
  DIGITS_ONLY_REGEX,
  LEADING_COMMA_REGEX,
} from '../../shared/constants/regex';

export const buildFullAddressText = (fields, cityDescription) => {
  const {
    AddressNumberPrefix,
    AddressNumber,
    AddressNumberSuffix,
    PreDirection,
    StreetName,
    StreetType,
    PostDirection,
    UnitType,
    UnitIdentifier,
    State,
    Postal,
  } = fields;

  const prefix = AddressNumberPrefix ? `${AddressNumberPrefix} ` : '';
  const number = AddressNumber ?? '';
  const suffix = AddressNumberSuffix ? ` ${AddressNumberSuffix}` : '';
  const pre = PreDirection ? ` ${PreDirection}` : '';
  const street = StreetName ? ` ${StreetName}` : '';
  const type = StreetType ? ` ${StreetType}` : '';
  const post = PostDirection ? ` ${PostDirection}` : '';
  const unit = UnitType && UnitIdentifier ? `, ${UnitType} ${UnitIdentifier}` : '';
  const city = cityDescription ? `, ${cityDescription}` : '';
  const state = State ? `, ${State}` : '';
  const postal = Postal ? ` ${Postal}` : '';

  const fullAddressText = `${prefix}${number}${suffix}${pre}${street}${type}${post}${unit}${city}${state}${postal}`;

  return fullAddressText.replace(LEADING_COMMA_REGEX, '');
};

export const validatePostcode = (postal) => POSTAL_CODE_REGEX.test(postal);

export const parsePostcode = (postal) => {
  if (!postal) return { PostalCode: null, PostalCodeExtension: null };

  const PostalCode =
    (postal.length === 5 || postal.length === 12) && DIGITS_ONLY_REGEX.test(postal.substr(0, 5))
      ? postal.substr(0, 5)
      : null;
  const PostalCodeExtension =
    postal.length === 12 && DIGITS_ONLY_REGEX.test(postal.substr(8, 4))
      ? postal.substr(8, 4)
      : null;

  return { PostalCode, PostalCodeExtension };
};

const DUPLICATE_CHECK_PARAM_FIELD_MAP = {
  AddressNum: 'AddressNumber',
  AddressNumPrefix: 'AddressNumberPrefix',
  AddressNumSuffix: 'AddressNumberSuffix',
  CityDescription: 'ptsCityID',
};

export const mapDuplicateCheckFields = (cdrRows) =>
  cdrRows
    .map((row) => row.Path.split('.').pop())
    .filter((param) => param !== 'CheckForDuplicates' && param !== 'UnitIdentifier')
    .map((param) => DUPLICATE_CHECK_PARAM_FIELD_MAP[param] || param);

export const mapCleryLocationFlags = (cleryLocationRadio) => ({
  IsCampusResidential: cleryLocationRadio === CLERY_LOCATION.CAMPUS_RESIDENTIAL,
  IsCampusNonResidential: cleryLocationRadio === CLERY_LOCATION.CAMPUS_NON_RESIDENTIAL,
  IsNonCampus: cleryLocationRadio === CLERY_LOCATION.NON_CAMPUS,
  IsPublic: cleryLocationRadio === CLERY_LOCATION.PUBLIC,
});

export const buildPostal = (postalCode, postalCodeExtension) => {
  if (!postalCode) return '';
  return postalCodeExtension ? `${postalCode} - ${postalCodeExtension}` : postalCode;
};

export const mapCleryFlagsToRadio = (address) => {
  if (address?.IsCampusResidential) return CLERY_LOCATION.CAMPUS_RESIDENTIAL;
  if (address?.IsCampusNonResidential) return CLERY_LOCATION.CAMPUS_NON_RESIDENTIAL;
  if (address?.IsNonCampus) return CLERY_LOCATION.NON_CAMPUS;
  if (address?.IsPublic) return CLERY_LOCATION.PUBLIC;
  return '';
};

// Copy editable fields only; record identity and audit metadata belong to the new record.
export const buildAddressCopyValues = (address, defaults) => ({
  ...Object.keys(defaults).reduce((values, key) => {
    values[key] = address[key] ?? defaults[key];
    return values;
  }, {}),
  ptsAddressID: null,
});
